import { Calendar, Clock } from "lucide-react";

const ProtectedRoute = ({ children }) => {
  const isAllowed = sessionStorage.getItem("isAllowed") === "true";
  const accessMessage = sessionStorage.getItem("accessMessage");

  if (!isAllowed) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="bg-white rounded-2xl shadow-lg p-8 max-w-xl w-full text-center">
          <div className="flex justify-center mb-4">
            <div className="bg-orange-100 p-4 rounded-full">
              <Clock size={40} className="text-orange-600" />
            </div>
          </div>

          <h1 className="text-2xl font-semibold text-gray-900 mb-3">
            Interview Not Yet Available
          </h1>

          <p className="text-gray-600 mb-6">
            Your interview session has not opened yet.
          </p>

          <div className="bg-blue-50 border border-blue-100 rounded-xl p-4 mb-6">
            <div className="flex items-center justify-center gap-2 text-blue-700">
              <Calendar size={18} />
              <span className="font-medium">Scheduled Start Time</span>
            </div>

            <p className="mt-2 text-lg font-semibold text-blue-900">
              04 Jun 2026 • 06:30 PM
            </p>
          </div>

          <p className="text-sm text-gray-500 mb-6">
            You can join the interview up to 15 minutes before the scheduled
            start time.
          </p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
